import api from './api';
import { AxiosResponse } from 'axios';

/**
 * A typed API client that simplifies working with API endpoints and response types
 */
export class ApiClient {
  /**
   * GET request with typed response
   */
  static async get<T>(url: string, params?: any): Promise<T> {
    try {
      // Get the full URL with params for debugging
      const urlSearchParams = new URLSearchParams();
      if (params) {
        Object.keys(params).forEach(key => {
          if (params[key] !== undefined) {
            urlSearchParams.append(key, params[key]);
          }
        });
      }
      
      const response: AxiosResponse<T> = await api.get(url, { params });
      
      return response.data;
    } catch (error) {
      console.error(`ApiClient.get error for ${url}:`, error);
      throw error;
    }
  }

  /**
   * POST request with typed request and response
   */
  static async post<T, D = any>(url: string, data?: D): Promise<T> {
    try {
      const response: AxiosResponse<T> = await api.post(url, data);
      return response.data;
    } catch (error) {
      console.error(`ApiClient.post error for ${url}:`, error);
      throw error;
    }
  }

  /**
   * PUT request with typed request and response
   */
  static async put<T, D = any>(url: string, data?: D): Promise<T> {
    try {
      const response: AxiosResponse<T> = await api.put(url, data);
      return response.data;
    } catch (error) {
      console.error(`ApiClient.put error for ${url}:`, error);
      throw error;
    }
  }

  /**
   * PATCH request with typed request and response
   */
  static async patch<T, D = any>(url: string, data?: D): Promise<T> {
    try {
      const response: AxiosResponse<T> = await api.patch(url, data);
      return response.data;
    } catch (error) {
      console.error(`ApiClient.patch error for ${url}:`, error);
      throw error;
    }
  }

  /**
   * DELETE request with typed response
   */
  static async delete<T>(url: string): Promise<T> {
    try {
      const response: AxiosResponse<T> = await api.delete(url);
      return response.data;
    } catch (error) {
      console.error(`ApiClient.delete error for ${url}:`, error);
      throw error;
    }
  }
}

export default ApiClient; 